<template>
  <div ref="instruction" class="instruction">
    <div class="instruction-item">
      <div class="instruction-item-title">
        <img src="@/assets/ribbon1.png" />
        <h2>{{ $t('instructions.youDidIt') }}</h2>
      </div>
      <div class="instruction-item-description">
        <h2>{{ $t('instructions.congratulations') }}</h2>
        <p>{{ $t('instructions.youAreDoneCluster') }}</p>
        <router-link
          :to="{
            name: 'testStart',
            params: { subject_id: $route.params.subject_id, cluster_id: $route.params.cluster_id },
          }"
        >
          <button type="button" class="btn btn-light continue">
            {{ $t('instructions.continue') }}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  watch: {},
  beforeCreate() {
    this.$emit('testStarted', true);
  },
  created() {
    this.$store.commit('showSidebar', false);
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.$refs.instruction.style.height =
        window.innerHeight - this.$refs.instruction.getBoundingClientRect().top + 'px';
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  font-size: 30px;
}
button {
  width: 200px;
  // height: 50px;
  background-color: #78c25f;
  border-radius: 10px;
  border-style: none;
  color: white;
  font-size: 30px;
  font-family: comfortaabold;
  line-height: 1;
}
.instruction {
  user-select: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.instruction-item {
  max-width: 600px;
  width: 100%;
  // margin-bottom: 60px;
}
.instruction-item-description {
  text-align: center;
}
.instruction-item-description h2 {
  font-size: 30px;
  font-weight: 900;
  margin-bottom: 0.5em;
  @include forTablet() {
    font-size: 50px;
  }
  font-family: comfortaabold;
  margin-top: 25px;
}
.instruction-item-description p {
  font-family: comfortaabold;
  margin: 0 0 25px 0;
  font-size: 26px;
}
.instruction-item-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.instruction-item-title h2 {
  font-family: comfortaabold;
  position: absolute;
  color: white;
  font-size: 40px;
  margin-top: 10px;
  @include forTablet() {
    font-size: 50px;
  }
}
.instruction-item-title img {
  width: 400px;
  height: 300px;
  display: block;
  margin: 0 auto;
}
.setting-item-description h2 {
  margin-top: 20px;
}
</style>
